import { useEffect, useState } from 'react';
import backendApi from './backendApi';
import { ProductVariantDataDto } from '../types/ProductVariant.types';

export const useProductVariantData = (
    backendApi: backendApi | undefined,
    productVariant: string,
    market: string,
    airflow: number | null,
    airflowUnit: string | null
) => {
    const [data, setData] = useState<ProductVariantDataDto>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (!backendApi) {
            return;
        }

        const params = new URLSearchParams({
            productVariant: productVariant,
            market: market
        });

        if (airflow) {
            params.append('airflow', airflow.toString());
        }

        if (airflowUnit) {
            params.append('airflowUnit', airflowUnit);
        }

        backendApi
            .getProductVariant(params)
            .then((response) => {
                setData(response);
            })
            .catch((error) => {
                setError(
                    error instanceof Error ? error.message : String(error)
                );
            })
            .finally(() => {
                setLoading(false);
            });
    }, [airflow, airflowUnit, backendApi, market, productVariant]);

    return { data, loading, error };
};
